import React from 'react';

export const Column = ({ children }) => (
  <div className="col-6 col-md">
    { children }
  </div>
);

export default Column;
